'use client';

import React, { useMemo } from 'react';

import { Icon, IconName, IconSize, Link } from '@bytel/trilogy-react';

import { WallType } from '@app-types/config';

import { getClientCookies } from '@helpers/cookies-client';

export type BackLinkProps = {
    baseUrl: string;
    type: WallType;
};

export function BackLink({ baseUrl, type }: Readonly<BackLinkProps>) {
    const wallFilter = getClientCookies(`${type}WallFilter`);
    const href = wallFilter ? `${baseUrl}/${wallFilter}` : baseUrl;

    const wording = useMemo(() => {
        switch (type) {
            case WallType.PHONE:
                return 'Retour vers tous les téléphones';
            case WallType.ACCESSORY:
                return 'Retour vers tous les accessoires';
            case WallType.HOTSPOT:
                return 'Retour vers tous les hotspots';
            case WallType.SALES_PHONE:
            case WallType.SALES_ACCESSORY:
                return 'Retour vers tous les bons plans';
            default:
                return 'Retour';
        }
    }, [type]);

    return (
        <Link className='is-flex is-aligned-center p-small' href={href}>
            <Icon name={IconName.ARROW_LEFT} size={IconSize.SMALL} />
            {wording}
        </Link>
    );
}
